/**
 * Friendly display labels for payments.method values recorded by the
 * backend. Unknown methods (including per-salon custom off-platform names)
 * pass through unchanged.
 */
const METHOD_LABELS: Record<string, string> = {
  Stripe_Card: "Card",
  Stripe_CardOnFile: "Card on File",
  Stripe_Affirm: "Affirm",
  Stripe: "Card",
};

export const formatPaymentMethod = (
  method: string | null | undefined,
): string => (method ? (METHOD_LABELS[method] ?? method) : "");
